// 商机管理
const BusinessOpportunity = () => import('@/pages/business/opportunity.vue');

const arr = [
  // 商机管理
  {
    path: '/business/opportunity',
    name: 'opportunity',
    component: BusinessOpportunity,
    meta: {
      auth: false,
    },
  },
];

export default arr;
